import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { Actions } from "../../../client/Actions";
import { LinkIconButton } from "../../components/button/LinkIconButton";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import { useModels } from "../../helpers/models";
import { ProductionTableActions } from "./ProductionTableActions";
import columns from "./ProductionTableConfig";

const ProductionTablePage = (props) => {

    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const [lines, setLines] = useState();
    const [installationCount, setInstallationsCount] = useState();
    const history = useHistory();
    const models = useModels();

    const createInventory = (machineId, onCreated) => {
        setLoader(true)
        // Actions.post("fontInventory/create", {machineId: machineId}, onCreated)
    }

    const actionColumn = {
        field: "actions",
        label: t("common.actions"),
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history, reload, setReload, setLoader) {
            return <ProductionTableActions
                history={history}
                row={row}
                reload={reload}
                setReload={setReload}
                setLoader={setLoader}
                createInventory={createInventory}
            />
        }
    }

    const loadLines = () => {
        setLoader(true)
        Actions.get("line", loadActiveProductions)
        Actions.get("line/installationsCounts", setInstallationsCount)
    }

    const loadActiveProductions = (loadedLines) => {
        Actions.get("production/active?lines=" + loadedLines.map(line => line.id).join(","), (productions) => activeProductionsLoaded(productions, loadedLines))
    }

    const activeProductionsLoaded = (productions, loadedLines) => {
        loadedLines.forEach(l => {
            l.production = productions[l.id]
        })

        setLines(loadedLines)
        setLoader(false)
    }

    useEffect(loadLines, [])

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("menu.production")}
                             
                             parent={
                                 <LinkIconButton
                                     model={models.production}
                                     props={props}
                                 />
                             }
            >


                <CardTable
                    title={t("common.line_list")}
                    initData={lines}
                    columns={columns(t).concat([actionColumn])}
                    width={12}
                    setLoader={setLoader}
                    striped={false}
                    shadow={true}
                    externalState={installationCount}
                />
            </CustomContainer>
        </>
    );
};

export default ProductionTablePage;
